export default __webpack_public_path__ + "static/media/image.ozi-solutions-pvt-ltd.39799126.png";